<template>
    <div style="padding: 10px">
        <el-table
                border
                :data="tableList"
                :header-cell-style="{
                            'background-color': '#EFF3F6',
                            'font-size': '14px',
                            'color': '#000000',
                        }">
            <el-table-column
                    prop="date"
                    type="index"
                    label="序号"
                    align="center"
                    width="50px">
                <template scope="scope">
                    <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="infoCategory"
                    align="center"
                    :show-overflow-tooltip="true"
                    label="信息大类">
            </el-table-column>
            <el-table-column
                    prop="subjectCode"
                    :show-overflow-tooltip="true"
                    align="center"
                    label="主体代码">
            </el-table-column>
            <el-table-column
                    prop="subjectName"
                    :show-overflow-tooltip="true"
                    label="主体名称"
                    align="left"
                    header-align="center">
            </el-table-column>
            <el-table-column
                    prop="infoType"
                    :show-overflow-tooltip="true"
                    align="center"
                    label="信息类型">
            </el-table-column>
            <el-table-column
                    prop="dataSource"
                    label="数据来源"
                    :show-overflow-tooltip="true"
                    width="100"
                    align="center">
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    label="登记时间"
                    width="100"
                    align="center">
                <template scope="scope">
                    <p>{{scope.row.createTime?formatDate(scope.row.createTime,"yyyy-MM-dd"):'--'}}</p>
                </template>
            </el-table-column>
            <el-table-column
                    label="操作"
                    fixed="right"
                    align="center">
                <template scope="scope">
                    <p class="btn-operation" @click="goDownload(scope.row)"><span>下载信用详细报告</span></p>
                </template>
            </el-table-column>
        </el-table>
        <!-- <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="total">
        </el-pagination> -->
    </div>
</template>
<script>
    import {mapState} from "vuex";
    export default {
        name: "credit-henan",
        data(){
            return {
                tableList:[],
                total:0,
                currentPage: 1,
                pageSize: 10
            }
        },
        computed: {
            ...mapState({
                orgId: (state) => state.user.orgId,
                entId: (state) => state.user.userinfo.userId,
                isAdmin: (state) => state.user.userPermStr == 'admin',
            })
        },
        created() {
            // this.queryList();
        },
        methods: {
            // 获取数据
            // queryList() {
            //     this.$httpReq.post('/entCreditHn/list',{
            //         page:this.currentPage,
            //         rows:this.pageSize,
            //         filter:{
            //             entId:this.$route.params.id || this.orgId,
            //         },
            //         searchKey: '',
            //         orderBy:'create_time desc'
            //     }).then((res)=>{
            //         if(res.data){
            //             this.tableList = res.data.rows;
            //             this.total = res.data.total;
            //             this.expands = [];
            //         }
            //     })

            // },
            // 下载信用详细报告
            goDownload(row){
                window.open (row.url)
            },
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                // this.queryData();
            },
        }
    }
</script>
<style lang="scss" scoped>

</style>